import React, { useState, useEffect } from "react";
import API from "../api";
import { Container, Form, Button, Spinner, Alert } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

export default function AdminGenerateSchedulePage() {
  const { user } = useAuth();
  const [leagues, setLeagues] = useState([]);
  const [selectedLeagueId, setSelectedLeagueId] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchLeagues = async () => {
      try {
        const res = await API.get("/league/all");
        setLeagues(res.data);
      } catch (err) {
        console.error("Failed to load leagues");
      } finally {
        setLoading(false);
      }
    };

    if (user?.role === 3) fetchLeagues(); // Only app admin
  }, [user]);

  const handleGenerate = async () => {
    if (!selectedLeagueId) return;

    const confirmed = window.confirm(
      "Are you sure you want to generate a schedule for this league? It will overwrite any existing schedule."
    );
    if (!confirmed) return;

    try {
      await API.post(`/league/admin/${selectedLeagueId}/regenerate-schedule`);
      setMessage("✅ Schedule successfully generated.");
    } catch (err) {
      console.error("Schedule generation error:", err);
      setMessage("❌ Failed to generate schedule.");
    }
  };

  if (loading) return <Spinner animation="border" className="m-5" />;

  return (
    <Container className="mt-4">
      <h4>Admin: Generate Schedule</h4>
      {message && <Alert variant="info">{message}</Alert>}

      <Form.Group className="mb-3">
        <Form.Label>Select League</Form.Label>
        <Form.Select
          value={selectedLeagueId}
          onChange={(e) => setSelectedLeagueId(e.target.value)}
        >
          <option value="">-- Select a League --</option>
          {leagues.map((league) => (
            <option key={league.id} value={league.id}>
              {league.name} (ID {league.id})
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Button
        variant="danger"
        onClick={handleGenerate}
        disabled={!selectedLeagueId}
      >
        Generate Schedule
      </Button>
    </Container>
  );
}
